// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading4_element__9MiU3"};